// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.IncomeProductsTab_container__8olAI {
  background-color: #f5f5f5;
  padding: 20px;
  border-radius: 12px;
}

/* Карточки */
.IncomeProductsTab_stats__vIRki {
  display: flex;
  gap: 20px;
  margin-bottom: 20px;
}

.IncomeProductsTab_card__kPELh {
  flex: 1 1;
  display: flex;
  align-items: center;
  gap: 12px;
  background: #fff;
  border-radius: 10px;
  padding: 16px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);
}

.IncomeProductsTab_card__kPELh p {
  font-size: 14px;
  color: #555;
  margin: 0;
}

.IncomeProductsTab_card__kPELh h3 {
  margin: 2px 0 0;
  font-weight: 600;
}

.IncomeProductsTab_cardIcon__A-ZF3 {
  font-size: 24px;
  opacity: 0.9;
}

.IncomeProductsTab_blue__wF3Yh .IncomeProductsTab_cardIcon__A-ZF3 {
  color: #007bff;
}

.IncomeProductsTab_green__3w-ih .IncomeProductsTab_cardIcon__A-ZF3 {
  color: #2e7d32;
}

.IncomeProductsTab_gray__DvD2q .IncomeProductsTab_cardIcon__A-ZF3 {
  color: #555;
}

/* Фильтры */
.IncomeProductsTab_filters__fixqx {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));
  gap: 16px;
  margin-bottom: 20px;
}

.IncomeProductsTab_filters__fixqx select,
.IncomeProductsTab_filters__fixqx input {
  background: #fff;
  border: 1px solid #ddd;
  border-radius: 8px;
  padding: 8px 12px;
  font-size: 14px;
  min-width: 160px;
  outline: none;
  transition: border-color 0.2s ease;
}

.IncomeProductsTab_filters__fixqx select:focus,
.IncomeProductsTab_filters__fixqx input:focus {
  border-color: #1d8752;
}

/* Таблица (твой стиль) */
.IncomeProductsTab_tableWrapper__wVZrv {
  max-height: 24vw;
  overflow-y: auto;
  overflow-x: auto;
  border: 1px solid #e0e0e0;
  border-radius: 8px;
  position: relative;
  background: #fff;
}

.IncomeProductsTab_table__Skqoz {
  width: 100%;
  border-collapse: collapse;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);
}

.IncomeProductsTab_table__Skqoz thead th {
  position: sticky;
  top: 0;
  z-index: 5;
  background-color: #f9f9f9;
}

.IncomeProductsTab_table__Skqoz th,
.IncomeProductsTab_table__Skqoz td {
  padding: 12px 16px;
  border-bottom: 1px solid #e0e0e0;
  text-align: left;
  font-size: 14px;
}

.IncomeProductsTab_table__Skqoz th {
  background-color: #f9f9f9;
  font-weight: 600;
  color: #333;
}

.IncomeProductsTab_table__Skqoz tr:hover {
  background-color: #f5f5f5;
}

.IncomeProductsTab_emptyText__t712V {
  text-align: center;
  color: #999;
  padding: 20px 0;
  font-style: italic;
}
`, "",{"version":3,"sources":["webpack://./src/pages/AnalyticsPages/IncomeProductsTab.module.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;AACrB;;AAEA,aAAa;AACb;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yCAAyC;AAC3C;;AAEA;EACE,eAAe;EACf,WAAW;EACX,SAAS;AACX;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,kCAAkC;AACpC;;AAEA;;EAEE,qBAAqB;AACvB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;EAChB,yBAAyB;EACzB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,gBAAgB;EAChB,MAAM;EACN,UAAU;EACV,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,eAAe;EACf,kBAAkB;AACpB","sourcesContent":[".container {\n  background-color: #f5f5f5;\n  padding: 20px;\n  border-radius: 12px;\n}\n\n/* Карточки */\n.stats {\n  display: flex;\n  gap: 20px;\n  margin-bottom: 20px;\n}\n\n.card {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  background: #fff;\n  border-radius: 10px;\n  padding: 16px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.05);\n}\n\n.card p {\n  font-size: 14px;\n  color: #555;\n  margin: 0;\n}\n\n.card h3 {\n  margin: 2px 0 0;\n  font-weight: 600;\n}\n\n.cardIcon {\n  font-size: 24px;\n  opacity: 0.9;\n}\n\n.blue .cardIcon {\n  color: #007bff;\n}\n\n.green .cardIcon {\n  color: #2e7d32;\n}\n\n.gray .cardIcon {\n  color: #555;\n}\n\n/* Фильтры */\n.filters {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(240px, 1fr));\n  gap: 16px;\n  margin-bottom: 20px;\n}\n\n.filters select,\n.filters input {\n  background: #fff;\n  border: 1px solid #ddd;\n  border-radius: 8px;\n  padding: 8px 12px;\n  font-size: 14px;\n  min-width: 160px;\n  outline: none;\n  transition: border-color 0.2s ease;\n}\n\n.filters select:focus,\n.filters input:focus {\n  border-color: #1d8752;\n}\n\n/* Таблица (твой стиль) */\n.tableWrapper {\n  max-height: 24vw;\n  overflow-y: auto;\n  overflow-x: auto;\n  border: 1px solid #e0e0e0;\n  border-radius: 8px;\n  position: relative;\n  background: #fff;\n}\n\n.table {\n  width: 100%;\n  border-collapse: collapse;\n  background: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.05);\n}\n\n.table thead th {\n  position: sticky;\n  top: 0;\n  z-index: 5;\n  background-color: #f9f9f9;\n}\n\n.table th,\n.table td {\n  padding: 12px 16px;\n  border-bottom: 1px solid #e0e0e0;\n  text-align: left;\n  font-size: 14px;\n}\n\n.table th {\n  background-color: #f9f9f9;\n  font-weight: 600;\n  color: #333;\n}\n\n.table tr:hover {\n  background-color: #f5f5f5;\n}\n\n.emptyText {\n  text-align: center;\n  color: #999;\n  padding: 20px 0;\n  font-style: italic;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `IncomeProductsTab_container__8olAI`,
	"stats": `IncomeProductsTab_stats__vIRki`,
	"card": `IncomeProductsTab_card__kPELh`,
	"cardIcon": `IncomeProductsTab_cardIcon__A-ZF3`,
	"blue": `IncomeProductsTab_blue__wF3Yh`,
	"green": `IncomeProductsTab_green__3w-ih`,
	"gray": `IncomeProductsTab_gray__DvD2q`,
	"filters": `IncomeProductsTab_filters__fixqx`,
	"tableWrapper": `IncomeProductsTab_tableWrapper__wVZrv`,
	"table": `IncomeProductsTab_table__Skqoz`,
	"emptyText": `IncomeProductsTab_emptyText__t712V`
};
export default ___CSS_LOADER_EXPORT___;
